import { useEffect } from 'react'
import { useDataService } from '@/data/DataServiceContext'
import { playMotif } from '@/lib/soundManager'

export function SoundEffects() {
  const service = useDataService()

  useEffect(() => {
    return service.subscribe((event) => {
      if (event.type === 'new-client') playMotif('new-client')
      else if (event.type === 'incident-closed') playMotif('incident-closed')
    })
  }, [service])

  return null
}
